module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/061d7919139982a9ee5541ac498d4828.gif";